import React, { useEffect } from "react";
import IconMaestro from "../../assets/images/existing-payments/IconMaestro";
import IconMasterCard from "../../assets/images/existing-payments/IconMasterCard";
import IconNotDefined from "../../assets/images/existing-payments/IconNotDefined";
import IconVisa from "../../assets/images/existing-payments/IconVisa";
import {
  CardExpire,
  CardInfo,
  CardNumber,
  CardType,
  StyleCard,
} from "./ExistingCardDataStyledComponent";

export const ExistingCardData = ({
  data,
  selectedPayment,
  colorSelected,
}: any) => {
  useEffect(() => { }, [colorSelected]);

  const cardsTypes = (paymentCard: any) => {
    if (isMastercard(paymentCard)) {
      return <IconMasterCard />;
    } else if (isMaestro(paymentCard)) {
      return <IconMaestro />;
    } else if (isVisa(paymentCard)) {
      return <IconVisa />;
    } else {
      return <IconNotDefined />;
    }
  };

  const isMastercard = (paymentCard: any): boolean => {
    let match: boolean = false;

    const masterCardStartWith = [51, 52, 53, 54, 55];
    const masterCardStarRange = 222100;
    const masterCardEndRange = 272099;

    if (
      Number(paymentCard.toString().substring(0, 6)) <= masterCardEndRange &&
      Number(paymentCard.toString().substring(0, 6)) >= masterCardStarRange
    ) {
      return true;
    } else {
      masterCardStartWith.forEach((startWithElem) => {
        if (paymentCard.toString().startsWith(startWithElem.toString())) {
          match = true;
        }
      });
    }
    return match;
  };
  const isMaestro = (paymentCard: any): boolean => {
    let match: boolean = false;

    const maestroCardStartWith = [
      5018, 5020, 5038, 5893, 6304, 6759, 6761, 6762, 6763,
    ];

    maestroCardStartWith.forEach((startWithElem) => {
      if (paymentCard.toString().startsWith(startWithElem.toString())) {
        match = true;
      }
    });

    return match;
  };

  const isVisa = (paymentCard: any): boolean => {
    return paymentCard.toString().startsWith("4");
  };

  const selectedCard = (data: any) => {
    selectedPayment(data);
  };

  return (
    <>
      <StyleCard onClick={() => selectedCard(data)} color={colorSelected}>
        {<CardType>{cardsTypes(data?.iin_number)}</CardType>}
        <CardInfo>
          <CardNumber>Tarjeta terminada en {data?.last4_digits}</CardNumber>
          <CardExpire>Caduca en {data?.expiration_date}</CardExpire>
        </CardInfo>
      </StyleCard>
      {/* <StyleCard onClick={() => selectedCard(data)} color={colorSelected}>
        {<CardType>{cardsTypes(data?.iin_number)}</CardType>}
        <CardInfo>
          <CardNumber>Tarjeta terminada en {data?.last4_digits}</CardNumber>
          <CardExpire>Caduca en {data?.expiration_date}</CardExpire>
        </CardInfo>
      </StyleCard> */}
    </>
  );
};
